export default __webpack_public_path__ + "static/media/greenarrow-icon.e877c6c0.svg";